import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IAnnotationService } from '../annotation.service';
import { IAnnotationsStore } from '../annotations.store';
import { IAnnotationUiStore } from '../annotationUi.store';
import { IFreeDrawSegmentationService } from '../freeDrawSegmentation.service';

interface IProps {
  readonly?: boolean;
}

export const ReturnToToolsContainer = observer((props: IProps): ReactElement => {
  const annotationService = useInjection(IAnnotationService.$);
  const freeDrawSegmentationService = useInjection(IFreeDrawSegmentationService.$);
  const uiStore = useInjection(IAnnotationUiStore.$);
  const annotationsStore = useInjection(IAnnotationsStore.$);

  const { t } = useTranslator();
  const { readonly } = props;

  const handleOnClick = async (): Promise<void> => {
    if (await freeDrawSegmentationService.clearAsync()) {
      uiStore.setIsInValidation(false);
      annotationService.deselectSegmentation();
    }
  };

  if (
    (readonly && !annotationsStore.isSelectedSegWithQuestions) ||
    (!readonly &&
      !freeDrawSegmentationService.freeDrawInProgress &&
      !annotationsStore.isSelectedSegWithQuestions &&
      !annotationsStore.isSelectedSegOfFreeDrawType)
  ) {
    return <></>;
  }

  return (
    <div className='questions-return'>
      <Button
        color='primary'
        variant='outlined'
        onClick={() => {
          void handleOnClick();
        }}
        startDecorator={<FontAwesomeIcon icon='angle-left' />}
      >
        {t('return_to_all_tools')}
      </Button>
    </div>
  );
});
